import React, { Component } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import bindModel from '../../../common/bindModel.js';


const $ = window.$;

export default class ModalHistoryGifts extends Component {
    constructor(props) {
        super(props);

        this.state = {
            receiverFacebookId: "",
            cursor: null,
            gifts: null,
            fromDate: null,
            toDate: null,
            statusButtonLoadPage: false,
            loading: false
        }

        this.getFirstHistory = this.getFirstHistory.bind(this);
        this.searchHistory = this.searchHistory.bind(this);
        this.loadMoreHistory = this.loadMoreHistory.bind(this);
        this.reset = this.reset.bind(this);
        this.setSentinel = this.setSentinel.bind(this);

    }

    componentWillUnmount() {
        if (this.observer) {
            this.observer.disconnect();
            this.observer = null;
        }
    }

    // Callback ref cho phần tử "mốc" đặt cuối bảng:
    // khi phần tử này lọt vào viewport thì tự động load thêm (giống tab Payment).
    setSentinel(node) {
        if (this.observer) {
            this.observer.disconnect();
            this.observer = null;
        }
        this.sentinelNode = node;

        if (!node || typeof IntersectionObserver === "undefined") return;

        this.observer = new IntersectionObserver(entries => {
            if (entries.some(entry => entry.isIntersecting)) {
                this.loadMoreHistory();
            }
        }, { rootMargin: "200px" });
        this.observer.observe(node);
    }

    // Sau khi load xong, nếu mốc vẫn nằm trong viewport (dữ liệu mới quá ngắn)
    // thì observe lại để trigger tiếp — IntersectionObserver chỉ bắn khi trạng thái đổi.
    rearmObserver() {
        if (this.observer && this.sentinelNode) {
            this.observer.unobserve(this.sentinelNode);
            this.observer.observe(this.sentinelNode);
        }
    }

    parseDateFilter() {
        let fromDate = null;
        let toDate = null;
        try {
            fromDate = Date.parse(this.state.fromDate);
        } catch (error) {
            fromDate = null;
        }
        try {
            toDate = Date.parse(this.state.toDate);
        } catch (error) {
            toDate = null;
        }
        return { fromDate, toDate };
    }

    // Nút search: query lại từ đầu theo khoảng ngày, thay toàn bộ list
    searchHistory() {
        const { loading } = this.state;
        if (loading) return;

        this.setState({ loading: true });
        const { fromDate, toDate } = this.parseDateFilter();
        let json = {
            receiverFacebookId: this.state.receiverFacebookId,
            cursor: null,
            fromDate: fromDate,
            toDate: toDate
        };

        axios.post(global.config.apiDomain + '/rest/admin/showGiftHistory', JSON.stringify(json), {
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(res => {
            this.setState({
                gifts: res.data.list,
                cursor: res.data.cursor,
                statusButtonLoadPage: res.data.list.length >= 100,
                loading: false
            }, () => this.rearmObserver());
        })
    }

    // Infinite scroll: nối trang sau vào list hiện tại theo cursor (giữ nguyên filter ngày)
    loadMoreHistory() {
        const { loading, statusButtonLoadPage } = this.state;
        if (loading || !statusButtonLoadPage) return;

        this.setState({ loading: true });
        const { fromDate, toDate } = this.parseDateFilter();
        let json = {
            receiverFacebookId: this.state.receiverFacebookId,
            cursor: this.state.cursor,
            fromDate: fromDate,
            toDate: toDate
        };

        axios.post(global.config.apiDomain + '/rest/admin/showGiftHistory', JSON.stringify(json), {
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(res => {
            this.setState({
                gifts: (this.state.gifts || []).concat(res.data.list),
                cursor: res.data.cursor,
                statusButtonLoadPage: res.data.list.length >= 100,
                loading: false
            }, () => this.rearmObserver());
        })
    }

    getFirstHistory(account) {
        if (account != null) {
            let json = {
                receiverFacebookId: this.state.receiverFacebookId,
            };
            axios.post(global.config.apiDomain + '/rest/admin/showGiftHistory', JSON.stringify(json), {
                headers: {
                    'Content-Type': 'application/json'
                }
            }).then(res => {
                console.log(res);
                let status = true;
                if (res.data.list.length < 100) {
                    status = false;
                }
                this.setState({
                    gifts: res.data.list,
                    cursor: res.data.cursor,
                    statusButtonLoadPage: status,
                    loading: false
                });
            })
        }
    }

    componentDidUpdate() {
        const { account } = this.props;
        // Điều kiện này đúng cả khi load lần đầu ("" !== id) lẫn khi đổi user
        // (idCũ !== idMới); sau khi set xong thì bằng nhau nên không refetch lặp.
        // (Bản cũ gọi getFirstHistory mỗi lần update khi gifts != null -> fetch liên tục.)
        if (account != null && this.state.receiverFacebookId !== account.id) {
            this.setState({
                receiverFacebookId: account.id,
                gifts: null,
                cursor: null,
                fromDate: null,
                toDate: null,
                statusButtonLoadPage: false,
            }, () => this.getFirstHistory(account));
        }
    }

    reset() {
        this.setState({
            fromDate: "",
            toDate: "",
            cursor: null
        });
    }


    render() {
        const model = bindModel(this);
        const { gifts, statusButtonLoadPage, loading } = this.state;

        return (
            <div>
                <br />
                <div className="input-group">
                    <input
                        className="form-control col-md-2 col-sm-6"
                        type="datetime-local"
                        id="fromDate"
                        name="fromDate"
                        placeholder="Từ ngày"
                        {...model('fromDate')}
                    />
                    <input
                        className="form-control col-md-2 col-sm-6"
                        type="datetime-local"
                        id="toDate"
                        name="toDate"
                        placeholder="Đến ngày"
                        {...model('toDate')}
                    />
                    <div className="input-group-append">
                        <button
                            className="btn btn-outline-success"
                            type="button"
                            id="button-addon2"
                            onClick={this.searchHistory}>
                            <i className="fa fa-search"></i>
                        </button>
                        <button
                            className="btn btn-outline-danger"
                            type="button"
                            id="button-addon2"
                            onClick={this.reset}>
                            <i className="fas fa-sync"></i>
                        </button>
                    </div>
                </div><br />

                <table className="table table-bordered">
                    <thead>
                        <tr>
                            <th className="align-middle text-center" scope="col" rowspan="2">Ngày nhận</th>
                            <th className="text-center" scope="col" colspan="3">Người tặng</th>
                            <th className="text-center" scope="col" colspan="6">Quà</th>
                            <th className="align-middle text-center" scope="col" colspan="2"></th>
                        </tr>
                        <tr>
                            <th className="text-center" scope="col">UID</th>
                            <th className="text-center" scope="col">Tên</th>
                            <th className="text-center" scope="col">Avatar</th>
                            <th className="text-center" scope="col">ID</th>
                            <th className="text-center" scope="col">Tên</th>
                            <th className="text-center" scope="col">Ảnh</th>
                            <th className="text-center" scope="col">Số lượng</th>
                            <th className="text-center" scope="col">Giá mua</th>
                            <th className="text-center" scope="col">Giá bán</th>
                            <th className="text-center" scope="col">Type</th>
                            <th className="text-center" scope="col">Chi tiết</th>
                        </tr>
                    </thead>
                    <tbody>
                        {gifts ? (
                            gifts.map((record, index) => {
                                return (
                                    <tr key={index}>
                                        <td>{new Date(record.addTime).toLocaleString()}</td>
                                        <td>{record.sender?.uid}</td>
                                        <td>{record.sender?.name}</td>
                                        <td>
                                            {record.sender?.profileImageLink &&
                                                <img src={record.sender.profileImageLink} height={100} width={100} />}
                                        </td>
                                        <td>{record.gift?.id}</td>
                                        <td>{record.gift?.name}</td>
                                        <td>
                                            {record.gift?.url &&
                                                <img src={record.gift.url} height={100} width={100} />}
                                        </td>
                                        <td>{record.gift?.noItem}</td>
                                        <td>{record.gift?.buyPrice}</td>
                                        <td>{record.gift?.sellPrice}</td>
                                        <td>{record.type}</td>

                                        {record.type === "LiveRoom" ? (
                                            <td>{record.liveRoom?.uid}</td>
                                        ) : record.type === "LuckyGift" ? (
                                            <td>{record.luckyGift?.name}</td>
                                        ) : record.type === "Recording" ? (
                                            <td><a href={record.recording?.onlineRecordingUrl}>{record.recording?.yourName}</a></td>
                                        ) : <></>}
                                    </tr>
                                )
                            })
                        ) : <></>}

                    </tbody>
                </table>

                {/* Mốc infinite scroll: scroll tới đây là tự load trang sau */}
                {gifts && gifts.length > 0 && (
                    <div ref={this.setSentinel} className="text-center mb-lg-4"
                         style={{ minHeight: "40px", padding: "10px 0" }}>
                        {loading ?
                            <span><i className="fa fa-spinner fa-spin"></i> Đang tải thêm...</span> :
                            (statusButtonLoadPage ?
                                <button onClick={this.loadMoreHistory} className="btn-red">Xem thêm</button> :
                                <span style={{ color: "#999" }}>Đã hiển thị hết</span>)}
                    </div>
                )}
            </div>
        )
    }
}